/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewScopeOfWorkComment } from '../models/new-scope-of-work-comment';
import { ScopeOfWorkComment } from '../models/scope-of-work-comment';
import { ScopeOfWorkCommentWithRelations } from '../models/scope-of-work-comment-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class ScopeOfWorkCommentControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation scopeOfWorkCommentControllerCount
   */
  static readonly ScopeOfWorkCommentControllerCountPath = '/scope-of-work-comments/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ScopeOfWorkCommentControllerService.ScopeOfWorkCommentControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation scopeOfWorkCommentControllerFindById
   */
  static readonly ScopeOfWorkCommentControllerFindByIdPath = '/scope-of-work-comments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ScopeOfWorkCommentWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ScopeOfWorkCommentControllerService.ScopeOfWorkCommentControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ScopeOfWorkCommentWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ScopeOfWorkCommentWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ScopeOfWorkCommentWithRelations>) => r.body as ScopeOfWorkCommentWithRelations)
    );
  }

  /**
   * Path part for operation scopeOfWorkCommentControllerDeleteById
   */
  static readonly ScopeOfWorkCommentControllerDeleteByIdPath = '/scope-of-work-comments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ScopeOfWorkCommentControllerService.ScopeOfWorkCommentControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation scopeOfWorkCommentControllerFind
   */
  static readonly ScopeOfWorkCommentControllerFindPath = '/scope-of-work-comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ScopeOfWorkCommentWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ScopeOfWorkCommentControllerService.ScopeOfWorkCommentControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ScopeOfWorkCommentWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ScopeOfWorkCommentWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ScopeOfWorkCommentWithRelations>>) => r.body as Array<ScopeOfWorkCommentWithRelations>)
    );
  }

  /**
   * Path part for operation scopeOfWorkCommentControllerCreate
   */
  static readonly ScopeOfWorkCommentControllerCreatePath = '/scope-of-work-comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewScopeOfWorkComment
  }): Observable<StrictHttpResponse<ScopeOfWorkComment>> {

    const rb = new RequestBuilder(this.rootUrl, ScopeOfWorkCommentControllerService.ScopeOfWorkCommentControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ScopeOfWorkComment>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewScopeOfWorkComment
  }): Observable<ScopeOfWorkComment> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ScopeOfWorkComment>) => r.body as ScopeOfWorkComment)
    );
  }

}
